import { services } from '../../../../constants/services';
import { removeWithQueryParams } from '../../../../utils/api';

export class DeleteCampusReservationLimitService {
	async run(params: any): Promise<void> {
		await removeWithQueryParams(`${services.campusReservationLimit}/deleteCampusReservationLimit`, params);
	}
}

